// Centraliza los strings de las rutas al API
const baseUrl = import.meta.env.VITE_BASE_URL as string;
const centralizedAuthUrl = (baseUrl + import.meta.env.VITE_CAS_URL) as string;
const governanceUrl = (baseUrl + import.meta.env.VITE_GOV_URL) as string;
const persistenceUrl = (baseUrl +
	import.meta.env.VITE_PERSISTENCE_URL) as string;
const gatewayUrl = (baseUrl + import.meta.env.VITE_GATEWAY_URL) as string;
const experimentationUrl = (baseUrl + import.meta.env.VITE_EXP_URL) as string;
const streamingUrl = (baseUrl + import.meta.env.VITE_STREAMING_URL) as string;
const notificationUrl = (baseUrl +
	import.meta.env.VITE_NOTIFICATION_URL) as string;
const sharingUrl = (baseUrl + import.meta.env.VITE_SHARING_URL) as string;
const login = import.meta.env.VITE_KEYCLOAK_URL as string;
const supportUrl = (baseUrl + import.meta.env.VITE_SUPPORT_URL) as string;
const marketplaceUrl = import.meta.env.VITE_MARKETPLACE_URL as string;
const customizationsUrl = (baseUrl +
	import.meta.env.VITE_CUSTOMIZATIONS_URL) as string;

export const API = {
	login: login,
	marketplaceWebsite: marketplaceUrl,
	centralizedAuth: {
		groups: "groups",
		group: `${centralizedAuthUrl}tenants`,
		invitations: `${centralizedAuthUrl}invitations/{0}`,
		users: `${centralizedAuthUrl}users`,
		permissions: `${centralizedAuthUrl}permissions`,
		resources: `${centralizedAuthUrl}resources`,
		roles: `${centralizedAuthUrl}roles`,
		conditionClause: `${centralizedAuthUrl}condition-clause`,
		organizations: `${centralizedAuthUrl}organizations`,
		parameters: `${centralizedAuthUrl}parameters`,
		tenant: `${centralizedAuthUrl}tenants`,
		passwordRestore: `${centralizedAuthUrl}password/restore`,
		request: {
			invitations: `${centralizedAuthUrl}request/invitations`,
			datasets: `${centralizedAuthUrl}request/datasets`,
			resources: `${centralizedAuthUrl}request/resources`,
			roles: `${centralizedAuthUrl}request/roles`,
		},
		usersCurrent: {
			user: `${centralizedAuthUrl}users/current`,
			profiles: `${centralizedAuthUrl}users/current/profiles`,
			password: `${centralizedAuthUrl}users/current/password`,
			menuOptions: {
				main: `${centralizedAuthUrl}users/current/menu-options/main`,
				user: `${centralizedAuthUrl}users/current/menu-options/user`,
				tab: `${centralizedAuthUrl}users/current/menu-options/tab`,
			},
			myOrganization: `${centralizedAuthUrl}users/current/organization`,
			requests: {
				invitations: `${centralizedAuthUrl}users/current/requests/invitations`,
				roles: `${centralizedAuthUrl}users/current/requests/roles`,
				resources: `${centralizedAuthUrl}users/current/requests/resources`,
			},
		},
		marketplace: {
			otc: `${centralizedAuthUrl}marketplace/otc`,
		},
		kpis: `${centralizedAuthUrl}kpi`,
		departments: `${centralizedAuthUrl}departments`,
		clause: `${centralizedAuthUrl}clause`,
		condition: `${centralizedAuthUrl}condition`,
	},
	experimentation: {
		experiments: `${experimentationUrl}experiments`,
		experimentsSearch: `${experimentationUrl}experiments/search`,
		checkRepo: `${experimentationUrl}experiments/check_repo`,
		artifacts: `${experimentationUrl}artifacts`,
		externalProducts: `${experimentationUrl}external-product`,
		parameters: `${experimentationUrl}parameters`,
		deploymentModes: `${experimentationUrl}/experiments/{0}/deployment/modes`,
	},
	governance: {
		accessRights: `${governanceUrl}v2/accessRights`,
		accessRightsDatasetPublishable: `${governanceUrl}v2/accessRights/dataset/{0}/publishable`,
		automations: `${governanceUrl}automations`,
		categories: `${governanceUrl}v2/categories`,
		formats: `${governanceUrl}formats`,
		glossaries: `${governanceUrl}glossaries`,
		glossariesv2: `${governanceUrl}v2/glossaries`,
		glossariesLite: `${governanceUrl}v2/glossaries/lite`,
		glossariesDeleted: `${governanceUrl}v2/glossaries/deleted`,
		glossaryTerms: `${governanceUrl}v2/glossaries/{0}/terms`,
		v2: `${governanceUrl}v2`,
		language: `${governanceUrl}language`,
		languagev2: `${governanceUrl}v2/languages`,
		search: `${governanceUrl}v2/datasets/search`,
		datasets: `${governanceUrl}datasets`,
		datasetsv2: `${governanceUrl}v2/datasets`,
		artifacts: `${governanceUrl}artifacts`,
		artifactsv2: `${governanceUrl}v2/structuredDistributions`,
		databases: `${governanceUrl}v2/databases`,
		tables: `${governanceUrl}v2/tables`,
		artifactColumnsv2: `${governanceUrl}v2/columns`,
		sharingPolicy: `${governanceUrl}sharing/policy`,
		sharingEDCCatalogue: `${governanceUrl}sharing/sharing-policy`,
		sharingAssets: `${governanceUrl}sharing/assets`,
		sharingRegion: `${governanceUrl}sharing/region`,
		sharingExternal: `${governanceUrl}sharing/external`,
		dataKind: `${governanceUrl}v2/data-kinds`,
		datasetsColumns: `${governanceUrl}v2/datasets/{0}/columns?page=0&size=500&unpaged=true`,
		metrics: `${governanceUrl}v2/metrics`,
		metricsForDataset: `${governanceUrl}v2/metrics/{0}`,
		metricRuleDetail: `${governanceUrl}v2/metrics/{0}/rules/{1}`,
		metricRuleExecution: `${governanceUrl}v2/metrics/{0}/rules/{1}/execution`,
		validationKinds: `${governanceUrl}v2/validation-kinds`,
		acceptanceCriteria: `${governanceUrl}v2/acceptance-criteria`,
		structuredDistributionById: `${governanceUrl}v2/structuredDistributions/{0}`,
		structuredDistributionColumns: `${governanceUrl}v2/structuredDistributions/{0}/columns`,
		databaseById: `${governanceUrl}v2/databases/{0}`,
		databaseTables: `${governanceUrl}v2/databases/{0}/tables`,
		tableById: `${governanceUrl}v2/tables/{0}`,
		termsSearch: `${governanceUrl}v2/terms/search`,
		termById: `${governanceUrl}v2/terms/{0}`,
		importTerms: `${governanceUrl}v2/terms/{0}/importTerms`,
		exportTerms: `${governanceUrl}v2/terms/{0}/exportTerms`,
		qualityMeasurements: `${governanceUrl}v2/quality/{0}/measurements`,
		validateImportAsset: `${governanceUrl}sharing/datasets/{0}/validate-import-asset/{1}`,
		importExternalDataset: `${governanceUrl}sharing/datasets/{0}/import-external-dataset/{1}`,
		connectors: {
			connectors: `${governanceUrl}sharing/connectors`,
			connectorById: `${governanceUrl}sharing/connectors/{0}`,
			connectorStatus: `${governanceUrl}sharing/connectors/{0}/status`,
			defaultConnector: `${governanceUrl}sharing/connectors/default`,
		},
		sharingRecord: {
			sharingRecord: `${governanceUrl}sharing/sharing-record`,
			sharingRecordById: `${governanceUrl}sharing/sharing-record/{0}`,
			sharingRecordByIdMetadata: `${governanceUrl}sharing/sharing-record/{0}/metadata`,
			sharingRecordByIdRepublish: `${governanceUrl}sharing/sharing-record/{0}/republish`,
			sharingRecordByDatasetId: `${governanceUrl}sharing/sharing-record/dataset/{0}`,
		},
		sharingPolicies: {
			byLang: `${governanceUrl}sharing/policy/{0}`,
		},
	},
	streaming: {
		base: `${streamingUrl}streaming`,
		technologiesTaskTypes: `${streamingUrl}technologies/task_type`,
		filetypes: `${streamingUrl}filetypes`,
		connector: `${streamingUrl}streaming/connector`,
		profilingArtifact: `${streamingUrl}profiling`,
		taskTypes: `${streamingUrl}task_types`,
		technologies: `${streamingUrl}technologies`,
	},
	persistence: {
		dataset: `${gatewayUrl}datasets`,
		datasetPersist: `${persistenceUrl}datasets`,
		quota: `${persistenceUrl}quota`,
		download: `${persistenceUrl}datasets`,
		parameter: `${persistenceUrl}parameter`,
		artifact: `${persistenceUrl}artifacts`,
		orient: `${persistenceUrl}orient`,
	},
	gateway: {
		datasets: {
			datasets: `${gatewayUrl}datasets`,
		},
		glossaries: `${gatewayUrl}glossaries`,
		consolidate: `${gatewayUrl}datasets`,
		experiments: `${gatewayUrl}experiments`,
	},
	notifications: {
		personal: `${notificationUrl}notifications/personal`,
	},
	sharing: {
		sharingNegotiate: `${sharingUrl}sharing/negotiate`,
		negotiationByAssetAndConnector: `${sharingUrl}sharing/negotiation/{0}/{1}`,
		transfer: `${sharingUrl}sharing/transfer`,
		transferStatus: `${sharingUrl}sharing/transfer-status`,
		isTransferCompleted: `${sharingUrl}sharing/is-transfer-completed`,
		dataspaces: `${sharingUrl}dataspaces`,
		credentials: `${sharingUrl}credentials`,
		credentialById: `${sharingUrl}credentials/{0}`,
		credentialPresentationById: `${sharingUrl}credentials/{0}/presentation`,
		externalCatalog: {
			search: `${sharingUrl}catalog/search/{0}`,
			datasetDetail: `${sharingUrl}catalog/search/assetDetail/{0}`,
			datasetDetailByConnector: `${sharingUrl}catalog/search/{0}/assetDetail/{1}`,
		},
	},
	report: {
		createUserReport: `${supportUrl}reports/user-reports`,
		errorCategories: `${supportUrl}reports/error-categories`,
	},
	customizations: {
		themeConfig: `${customizationsUrl}api/v1/update-config`,
		themeConfigLogos: `${customizationsUrl}api/v1/update-config/logos`,
		favicon: `${customizationsUrl}api/v1/update-config/favicon`,
	},
};
